module.exports = __webpack_public_path__ + "static/media/voult-animation-logo.6fd6f466.svg";